import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { Button, TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { FaTrash } from 'react-icons/fa';

interface TriggerEditFormProps {
    trigger: any;
    onSave: (trigger: any) => void;
    onDelete: () => void;
}

const TriggerEditForm = ({ trigger, onSave, onDelete }: TriggerEditFormProps) => {
    console.log("TriggerEditForm.trigger", trigger);

    const { register, handleSubmit, control } = useForm({
        defaultValues: {
            settings: trigger?.settings || {},
        },
        mode: "onChange",
    });

    const onSubmit = (formInput: any) => {
        console.log("formInput", formInput);
        onSave({
            ...trigger,
            settings: formInput.settings,
        });
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid gap-4">
                {trigger?.triggerType?.schema?.fields?.map((field: any) => {
                    if (field.type === "string") {
                        return (
                            <div key={field.key}>
                                <TextField
                                    fullWidth
                                    label={field.label}
                                    {...register(`settings.${field.key}`)}
                                />
                            </div>
                        );
                    }
                    if (field.type === "number") {
                        return (
                            <div key={field.key}>
                                <TextField
                                    label={field.label}
                                    {...register(`settings.${field.key}`)}
                                />
                            </div>
                        );
                    }
                    if (field.type === "boolean") {
                        return (
                            <div key={field.key}>
                                <TextField
                                    label={field.label}
                                    {...register(`settings.${field.key}`)}
                                />
                            </div>
                        );
                    }
                    if (field.type === "string[]") {
                        return (
                            <div key={field.key} id={field.key} className="mb-4 mt-4">
                                <Controller
                                    control={control}
                                    name={`settings.${field.key}`}
                                    defaultValue={[]}
                                    render={({ field: f }: { field: any }) => (
                                        <Autocomplete
                                            value={f.value || []}
                                            onChange={(_, value) => f.onChange(value)}
                                            multiple
                                            freeSolo
                                            options={[]} // Можно оставить пустым, если подсказки не нужны
                                            renderInput={(params: any) => (
                                                <TextField {...params} id={field.key} label={field.label} helperText="Нажмите Enter для добавления" />
                                            )}
                                        />
                                    )}
                                />
                            </div>
                        );
                    }
                })}
            </div>
            <div className="mt-4 flex gap-2">
                <Button type="submit" variant="contained" color="primary" >Сохранить</Button>
                {/* Delete trigger button */}
                <Button type="button" variant="outlined" color="error" onClick={() => onDelete()}>
                    <FaTrash />
                </Button>
            </div>
        </form>
    )
}

export default TriggerEditForm;